// extracted by mini-css-extract-plugin
export default {"MaterialButton":"Button_MaterialButton__rgrPa","a8-btn-sheen":"Button_a8-btn-sheen__N6DDV"};